import { createApiClient } from "@app/utils/apiClient";

export const expressClient = createApiClient(
  process.env.EXPRESS_API_BASE_URL,
  null,
  1,
  {
    "Content-Type": "application/json",
    "x-api-key": process.env.EXPRESS_API_CLIENT_ID,
  },
);

export const getTaggedDocuments = async (
  { nextUrl, filters } = {},
  options = {},
) => {
  if (!nextUrl) {
    throw new Error("nextUrl is required");
  }

  const response = await expressClient.get(nextUrl, {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch tagged documents", {
      cause: response.data,
    });
  }

  if (Array.isArray(filters?.documents)) {
    // Apply client-side filtering if filters are provided
    response.data.documents = response.data.documents.filter((item) =>
      filters.documents.includes(item.id),
    );
  }

  response.data.documents = response.data.documents.map((doc) => ({
    ...doc,
    name: doc.name.replace(/\.[^/.]+$/, ""),
  }));

  return response.data;
};

export const getTaggedDocument = async ({ nextUrl } = {}, options = {}) => {
  if (!nextUrl) {
    throw new Error("nextUrl is required");
  }

  const response = await expressClient.get(nextUrl, {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch tagged document", {
      cause: response.data,
    });
  }

  return response.data;
};

export const generateVariation = async (payload, options = {}) => {
  const response = await expressClient.post(
    `/beta/generate-variation`,
    payload,
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to generate variation", {
      cause: response.data,
    });
  }

  return response.data;
};

export const getStatus = async (jobId, options = {}) => {
  const response = await expressClient.get(`/status/${jobId}`, {}, options);

  if (!response.ok) {
    throw new Error("Failed to fetch status", {
      cause: response.data,
    });
  }

  return response.data;
};

export const pollStatus = async (jobId, interval = 1000, options = {}) => {
  return new Promise((resolve, reject) => {
    const poll = setInterval(async () => {
      try {
        const statusResponse = await getStatus(jobId, options);

        if (
          ["partially_succeeded", "succeeded"].includes(statusResponse.status)
        ) {
          clearInterval(poll);
          resolve(statusResponse);
        } else if (statusResponse.status === "failed") {
          console.log(statusResponse);
          clearInterval(poll);
          reject(
            new Error(statusResponse.message || "Job failed", {
              cause: statusResponse,
            }),
          );
        }
      } catch (error) {
        clearInterval(poll);
        reject(error);
      }
    }, interval);
  });
};

export const exportRendition = async (payload = {}, options = {}) => {
  const response = await expressClient.post(
    `/beta/export-rendition`,
    payload,
    options,
  );

  if (!response.ok) {
    throw new Error("Failed to export rendition", {
      cause: response.data,
    });
  }

  return response.data;
};
